import React, { Suspense, lazy } from 'react';
import { Loading } from 'react-admin';

const UserList = lazy(() => import('./UserList'));
const UserEdit = lazy(() => import('./UserEdit'));

const Users = {
    name: 'profile',
    list: (props) => (
        <Suspense fallback={<Loading />}>
            <UserList {...props} />
        </Suspense>
    ),
    edit: (props) => (
        <Suspense fallback={<Loading />}>
            <UserEdit {...props} />
        </Suspense>
    ),
    // Assuming UserCreate would be handled similarly if it were defined
};

export default Users;
